module.exports = __webpack_public_path__ + "img/store1.737635c5.jpg";